/**
 * transitions-dev orchestration for Lumyn theme surfaces.
 */
(function () {
  function parseMs(token, fallback) {
    const raw = getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    const value = parseFloat(raw);
    return Number.isFinite(value) ? value : fallback;
  }

  function bindDropdownClose(details) {
    const panel = details.querySelector(':scope > .t-dropdown');
    const summary = details.querySelector(':scope > summary');
    if (!panel || !summary) return;

    summary.addEventListener('click', (event) => {
      if (!details.hasAttribute('open') || panel.classList.contains('is-closing')) return;
      event.preventDefault();
      const closeMs = parseMs('--dropdown-close-dur', 150);
      panel.classList.remove('is-open');
      panel.classList.add('is-closing');
      window.setTimeout(() => {
        panel.classList.remove('is-closing');
        details.removeAttribute('open');
      }, closeMs);
    });

    details.addEventListener('toggle', () => {
      if (details.hasAttribute('open')) {
        panel.classList.remove('is-closing');
        panel.classList.add('is-open');
        return;
      }
      if (!panel.classList.contains('is-closing')) {
        panel.classList.remove('is-open');
      }
    });
  }

  function initDropdowns() {
    document.querySelectorAll('header-menu details, details-disclosure details').forEach((details) => {
      if (details.querySelector(':scope > .t-dropdown')) {
        bindDropdownClose(details);
      }
    });
  }

  function replayBadge(badge) {
    badge.setAttribute('data-open', 'false');
    void badge.offsetWidth;
    badge.setAttribute('data-open', 'true');
  }

  function initCartBadges() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      document.querySelectorAll('.cart-count-bubble.t-badge[data-open="true"]').forEach(replayBadge);
    });
  }

  function init() {
    initDropdowns();
    initCartBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
